import config from '@app/config'
import { isB2BView } from '@app/utils'

export const isSafari = () => {
  const ua = navigator.userAgent
  return (
    /Safari/i.test(ua) &&
    /iPhone|iPad|iPod/i.test(ua) &&
    !/CriOS|FxiOS|OPiOS|mercury/i.test(ua)
  )
}

export const getAppUrl = () => {
  const pathParts = window.location.pathname.split('/').filter(Boolean)
  const conversationId = pathParts[1]
  const isB2B = isB2BView()

  return `${config.variables.applink}?path=messages${conversationId ? `&conversationId=${conversationId}` : ''}${
    isB2B ? '&source=dashboard' : ''
  }`
}
